var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 2.5a.793.793 0 0 0-.796.791v4.38a.797.797 0 0 0 .797.797.793.793 0 0 0 .793-.798V3.291a.794.794 0 0 0-.793-.791zM6.05 5.753a.793.793 0 0 0-.563 1.354l3.097 3.103A.795.795 0 1 0 9.71 9.083L6.607 5.988a.794.794 0 0 0-.557-.234zm6.038 6.01a.792.792 0 0 0-.796 1.008l4.462 16.147a.793.793 0 0 0 1.448.194l2.627-4.467 3.634 3.634a.794.794 0 0 0 1.12 0l3.196-3.195a.795.795 0 0 0 0-1.12l-3.67-3.67 4.49-2.585a.794.794 0 0 0-.18-1.455L12.27 11.792a.788.788 0 0 0-.183-.03zm-9.297 3.37a.795.795 0 0 0 0 1.59h4.38a.792.792 0 0 0 .797-.792.796.796 0 0 0-.798-.797H2.791z",
    fill: "#FFE14B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.247c6bb36474046f479cb167f38cc21b.svg";
export { ForwardRef as ReactComponent };